import { render } from "./PageViewer.vue?vue&type=template&id=6d2796a1&scoped=true"
import script from "./PageViewer.vue?vue&type=script&lang=js"
export * from "./PageViewer.vue?vue&type=script&lang=js"

import "./PageViewer.vue?vue&type=style&index=0&id=6d2796a1&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\luis_\\OneDrive\\PAGINAS WEB\\museo-cristal-final\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2796a1"]])

export default __exports__